import createSourcesModule from "@/config/store/sources"

export default createSourcesModule("/sources_shops")
